import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        homeData: null,
        globalData: null,
        units: null,
        blogs: null,
        unitsFilter: null,
        provinces: null,
        cities: null,
        countries: null,
        blogCategories: null,
        industrialPark:null,
        singleBlog: null
    },
    mutations: {
        setIndustrialPark(state,list){
            state.industrialPark=list;
        },
        setSingleBlog(state, blog) {
            state.singleBlog = blog;
        },
        setprovinces(state, list) {
            state.provinces = list;
        },
        setcities(state, list) {
            state.cities = list;
        },
        setcountries(state, list) {
            state.countries = list;
        },
        setBlogsCategories(state, list) {
            state.blogCategories = list;
        },
        setBlogs(state, data) {
            state.blogs = data;
        },
        setUnits(state, data) {
            state.units = data;
        },
        setUnitsFilter(state, data) {
            state.unitsFilter = data;
        },
        setGlobalData(state, data) {
            state.globalData = data;
        },
        setHomeData(state, data) {
            state.homeData = data;
        }
    },
    getters: {
        getSingleBlog(state) {
            return state.singleBlog;
        },
        getprovinces(state) {
            return state.provinces;
        },
        getcities(state) {
            return state.cities;
        },
        getcountries(state) {
            return state.countries;
        },
        getBlogCategories(state) {
            return state.blogCategories;
        },
        getBlogs(state) {
            return state.blogs;
        },
        getUnits(state) {
            return state.units;
        },
        getUnitsFilter(state) {
            return state.unitsFilter;
        },
        getGlobalData(state) {
            return state.globalData;
        },
        getHomeData(state) {
            return state.homeData;
        },
        getIndustrialPark(state){
            return state.industrialPark
        }
    },
    actions: {
        getIndustrialParkFromServer({commit}){
            axios.get(`front/towns`).then((res) => {
                commit("setIndustrialPark", res.data.towns);
            });
        },
        getSingleBlogFromServer({ commit }, id) {
            axios.get(`front/posts/${id}`).then((res) => {
                commit("setSingleBlog", res.data.post);
                console.log(prefetch);
            });
        },

        getHomeDataFromServer({ commit }) {
            axios.get("front/home").then((res) => {
                let banners = {};
                res.data.home.banners.forEach((item) => {
                    banners[item.position] = item;
                });
                res.data.home.banners = banners;
                commit("setHomeData", res.data.home);
            });
        }
    }
});